<template>
  <div class="">
    <div id="contnChow1232" ref="mapContainer"></div>
    <div class="dialog flexCol alit justc" v-if="dialogVisible">
      <div class="mask" @click="dialogVisible = false"></div>
      <div class="cont" style="width: 54vw; padding: 20px">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%85%B3%E9%97%AD%20%282%29.png"
          class="dialog-close"
          alt=""
          @click="dialogVisible = false"
        />
        <div class="flex justb" style="margin: 0 40px 0 0">
          <div class="flex">
            <el-dropdown>
              <el-button type="primary" class="search2">
                选择地块<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>地块1</el-dropdown-item>
                <el-dropdown-item>地块2</el-dropdown-item>
                <el-dropdown-item>地块3</el-dropdown-item>
                <el-dropdown-item>地块4</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown>
              <el-button type="primary" class="search2">
                选择分组<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>分组1</el-dropdown-item>
                <el-dropdown-item>分组2</el-dropdown-item>
                <el-dropdown-item>分组3</el-dropdown-item>
                <el-dropdown-item>分组4</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="search" @click="setShow(true)">全部展开</div>
            <div class="search" @click="setShow(false)">全部收起</div>
          </div>
          <div class="search" @click="openKeyGroup">一键开启</div>
        </div>
        <div class="" style="height: 55vh; overflow: auto">
          <div
            class=""
            v-for="(item, index) in tableList"
            :key="index"
            style="margin-top: 20px"
          >
            <div
              class="flex alit"
              style="margin-left: 2.5%; cursor: pointer"
              @click="item.show = !item.show"
            >
              <div class="flex alit" style="width: 200px">
                <el-checkbox
                  v-model="item.ischeck"
                  style="margin-top: 10px; margin-right: 10px"
                ></el-checkbox>
                <div class="table-name">{{ index + 1 }}组</div>
              </div>
              <div class="flex" style="flex: 1" @click.stop>
                <div class="flex alit">
                  <div class="table-search">统一时间：</div>
                  <el-input
                    style="width: 150px"
                    placeholder="统一时间"
                    size="mini"
                  ></el-input>
                </div>
                <div class="flex alit" style="margin-left: 30px">
                  <div class="table-search">统一开度：</div>
                  <el-input
                    style="width: 150px"
                    placeholder="统一开度"
                    size="mini"
                  ></el-input>
                </div>

                <img
                  src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%A8%A1%E5%BC%8F%E5%BC%80%E5%90%AF%402x.png"
                  style="
                    width: 30px;
                    height: 30px;
                    cursor: pointer;
                    margin-left: 10px;
                  "
                  alt=""
                />
                <div class="flex alit" style="margin-left: 30px">
                  <div class="table-search">顺序：</div>
                  <el-input
                    style="width: 80px"
                    placeholder="顺序"
                    size="mini"
                  ></el-input>
                </div>
              </div>
            </div>

            <el-table
              :data="item.tableData"
              class="outer-border-table"
              v-if="item.show"
              style="width: 95%; margin-left: 2.5%; margin-top: 5px"
              :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
            >
              <el-table-column prop="name" label="水阀名称" align="center">
              </el-table-column>
              <el-table-column prop="status" label="水阀状态" align="center">
              </el-table-column>
              <el-table-column prop="dl" label="电量" align="center">
              </el-table-column>
              <el-table-column prop="time" label="灌溉时长" align="center">
              </el-table-column>
              <el-table-column prop="kd" label="开度" align="center">
              </el-table-column>
              <el-table-column prop="sy" label="水压" align="center">
              </el-table-column>
              <el-table-column prop="ll" label="流量" align="center">
              </el-table-column>
              <el-table-column
                prop="timeCount"
                label="已灌溉时长"
                align="center"
              >
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <img
                    src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%A8%A1%E5%BC%8F%E5%85%B3%E9%97%AD%402x.png"
                    v-if="scope.row.status == '关闭'"
                    style="
                      width: 30px;
                      height: 30px;
                      cursor: pointer;
                      margin-left: 10px;
                    "
                    @click="openOrCloseDevice"
                    alt=""
                  />

                  <img
                    src="https://ica.obs.cn-south-1.myhuaweicloud.com/guangai/%E6%A8%A1%E5%BC%8F%E5%BC%80%E5%90%AF%402x.png"
                    v-if="scope.row.status == '开启'"
                    style="
                      width: 30px;
                      height: 30px;
                      cursor: pointer;
                      margin-left: 10px;
                    "
                    @click="openOrCloseDevice"
                    alt=""
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 气象检测仪 -->
    <div class="dialog flexCol alit justc" v-if="dialogQxVisible">
      <div class="mask" @click="dialogQxVisible = false"></div>
      <div class="cont" style="background-color: #071f39; min-width: 30vw">
        <div class="cq" style="margin-top: 5px">
          <div class="fout-emotions-title">气象检测仪</div>
          <div class="content flex alit"></div>
        </div>
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%85%B3%E9%97%AD%20%282%29.png"
          class="dialog-close"
          alt=""
          @click="dialogQxVisible = false"
        />
        <div class="flexCol sqtext">
          <div class="flex">
            <div class="" style="width: 40%">温度:22℃</div>
            <div class="">湿度:70.7%</div>
          </div>
          <div class="flex">
            <div class="" style="width: 40%">空气质量:44ug</div>
            <div class="">等级:2级</div>
          </div>
          <div class="flex">
            <div class="" style="width: 40%">描述:优良</div>
            <div class="">风力:东南风 2级 6km/h</div>
          </div>
          <div class="flex">
            <div class="" style="width: 40%">能见度:10km</div>
            <div class="">气压:850pa</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 墒情 -->
    <div class="dialog flexCol alit justc" v-if="dialogSqVisible">
      <div class="mask" @click="dialogSqVisible = false"></div>
      <div class="cont" style="background-color: #071f39; min-width: 30vw">
        <div class="cq" style="margin-top: 5px">
          <div class="fout-emotions-title">土壤墒情</div>
          <div class="content flex alit"></div>
        </div>
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%85%B3%E9%97%AD%20%282%29.png"
          class="dialog-close"
          alt=""
          @click="dialogSqVisible = false"
        />
        <div class="flexCol sqtext">
          <div class="flex">
            <div class="" style="width: 40%">氮:210.01mg/kg</div>
            <div class="">磷:96.08mg/kg</div>
          </div>
          <div class="flex">
            <div class="" style="width: 40%">钾:133.02mg/kg</div>
            <div class="">土壤相对湿度:44.2%</div>
          </div>
          <div class="flex">
            <div class="" style="width: 40%">含水率:11.4%</div>
            <div class="">空气湿度:70.7%</div>
          </div>
          <div class="flex">
            <div class="" style="width: 40%">土壤温度:12.3C</div>
            <div class="">光照度:469Lux</div>
          </div>
          <div class="flex">
            <div class="" style="width: 40%">土壤PH值:3.5</div>
            <div class=""></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 苗情 -->
    <div class="dialog flexCol alit justc" v-if="dialogMqVisible">
      <div class="mask" @click="dialogMqVisible = false"></div>
      <div class="cont" style="background-color: #071f39">
        <div class="cq" style="margin-top: 5px">
          <div class="fout-emotions-title">苗情影像</div>
          <div class="content flex alit"></div>
        </div>
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%85%B3%E9%97%AD%20%282%29.png"
          class="dialog-close"
          alt=""
          @click="dialogMqVisible = false"
        />
        <div
          id="mse"
          style="width: 100%; height: 100%; border-radius: 10px"
        ></div>
      </div>
    </div>

    <!-- 虫情 -->
    <div class="dialog flexCol alit justc" v-if="dialogCqVisible">
      <div class="mask" @click="dialogCqVisible = false"></div>
      <div
        class="cont"
        style="background-color: #071f39; width: 800px; height: 480px"
      >
        <div class="cq" style="margin-top: 5px">
          <div class="fout-emotions-title">虫情</div>
          <div class="content flex alit">
            <img
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%99%AB%E6%83%85%E6%B5%8B%E6%8A%A5%E4%BB%AA.png"
              style="width: 270px; height: 440px; margin: 0 10px"
              alt=""
            />

            <div
              class=""
              style="flex: 1; margin-right: 20px; margin-left: 40px"
            >
              <div class="flex justb" style="margin-right: 10px; width: 300px">
                <div class="flex alit cq-right-top-title">运行模式</div>
                <div class="flex justb" style="flex: 1">
                  <div
                    class="sd"
                    v-if="operatingMode"
                    @click="operatingMode = false"
                  >
                    手动
                  </div>
                  <div class="zd" v-else @click="operatingMode = true">
                    自动
                  </div>
                  <div class="paizhao flex alit justc">
                    <img
                      style="width: 21px; height: 17px; margin-right: 10px"
                      src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E7%9B%B8%E6%9C%BA%402x.png"
                      alt=""
                    />
                    拍照
                  </div>
                </div>
              </div>
              <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                <div class="flex alit">
                  <div class="cq-right-top-title">诱虫灯</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value1 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value1"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    />
                  </div>
                </div>
                <div class="flex alit" style="margin-right: 70px">
                  <div class="cq-right-top-title2">虫雨挡板</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value2 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value2"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    >
                    </el-switch>
                  </div>
                </div>
              </div>
              <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                <div class="flex alit">
                  <div class="cq-right-top-title">杀虫挡板</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value3 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value3"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    >
                    </el-switch>
                  </div>
                </div>
                <div class="flex alit" style="margin-right: 70px">
                  <div class="cq-right-top-title2">烘干挡板</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value4 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value4"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    >
                    </el-switch>
                  </div>
                </div>
              </div>
              <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                <div class="flex alit">
                  <div class="cq-right-top-title">移虫装置</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value5 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value5"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    >
                    </el-switch>
                  </div>
                </div>
                <div class="flex alit" style="margin-right: 70px">
                  <div class="cq-right-top-title2">杀虫控制</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value6 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value6"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    >
                    </el-switch>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%85%B3%E9%97%AD%20%282%29.png"
            class="dialog-close"
            alt=""
            @click="dialogCqVisible = false"
          />
        </div>
      </div>
    </div>

    <!-- 孢子检测仪 -->
    <div class="dialog flexCol alit justc" v-if="dialogBzVisible">
      <div class="mask" @click="dialogBzVisible = false"></div>
      <div
        class="cont"
        style="background-color: #071f39; width: 800px; height: 480px"
      >
        <div class="cq" style="margin-top: 5px">
          <div class="fout-emotions-title">孢子</div>
          <div class="content flex alit">
            <img
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/a645441470ef28a9f892f3713c55f4b7.png"
              style="width: 230px; height: 400px; margin: 20px"
              alt=""
            />

            <div
              class=""
              style="flex: 1; margin-right: 20px; margin-left: 40px"
            >
              <div class="flex justb" style="margin-right: 10px; width: 300px">
                <div class="flex alit cq-right-top-title">运行模式</div>
                <div class="flex justb" style="flex: 1">
                  <div
                    class="sd"
                    v-if="operatingMode"
                    @click="operatingMode = false"
                  >
                    手动
                  </div>
                  <div class="zd" v-else @click="operatingMode = true">
                    自动
                  </div>
                  <div class="paizhao flex alit justc">
                    <img
                      style="width: 21px; height: 17px; margin-right: 10px"
                      src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E7%9B%B8%E6%9C%BA%402x.png"
                      alt=""
                    />
                    拍照
                  </div>
                </div>
              </div>

              <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                <div class="flex alit">
                  <div class="cq-right-top-title">光源</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value1 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value1"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    />
                  </div>
                </div>
                <div class="flex alit" style="margin-right: 70px">
                  <div class="cq-right-top-title2">吸风风扇</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value2 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value2"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    >
                    </el-switch>
                  </div>
                </div>
              </div>
              <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                <div class="flex alit">
                  <div class="cq-right-top-title">排风风扇</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value3 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value3"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    >
                    </el-switch>
                  </div>
                </div>
                <div class="flex alit" style="margin-right: 70px">
                  <div class="cq-right-top-title2">载波带电机运行</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value4 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value4"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    >
                    </el-switch>
                  </div>
                </div>
              </div>
              <div class="flex justb" style="flex: 1; margin: 70px 10px 18px 0">
                <div class="flex alit">
                  <div class="cq-right-top-title">采样电机运行</div>
                  <div class="switch-group">
                    <div class="cq-right-top-status">
                      {{ value5 ? "开" : "关" }}
                    </div>
                    <el-switch
                      v-model="value5"
                      :width="47"
                      active-color="#53c556"
                      inactive-color="#b2b2b2"
                    >
                    </el-switch>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%85%B3%E9%97%AD%20%282%29.png"
            class="dialog-close"
            alt=""
            @click="dialogBzVisible = false"
          />
        </div>
      </div>
    </div>

    <div class="dialog flexCol alit justc" v-if="irrigation">
      <div class="mask" @click="irrigation = false"></div>
      <div class="cont">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%85%B3%E9%97%AD%20%282%29.png"
          class="dialog-close"
          alt=""
          @click="irrigation = false"
        />
        <irrigationVue></irrigationVue>
      </div>
    </div>

    <el-dialog
      title="水阀参数设置"
      :visible.sync="dialogFormVisible"
      width="400px"
    >
      <el-form :model="form">
        <el-form-item label="灌溉时长（分钟）">
          <el-input v-model="form.time" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="间隔时间（小时）">
          <el-input v-model="form.num" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="浇灌顺序">
          <el-input v-model="form.sort" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="start">确 定</el-button>
      </div>
    </el-dialog>

    <div class="dialog flexCol alit justc noselect" v-if="zzym">
      <div class="mask" @click="zzym = false"></div>
      <zzymVue @close="zzym = false"></zzymVue>
    </div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import {
  transformWGS84ToBD09,
  transformBD09ToGCJ02,
  transformBD09ToWGS84,
  transformGCJ02ToWGS84,
  transformWGS84ToGCJ02,
} from "@isvend/coord-transform";
import irrigationVue from "./irrigation.vue";

import Player from "xgplayer";
import FlvPlugin from "xgplayer-flv";
import "xgplayer/dist/index.min.css";
import zzymVue from "@/components/zzym.vue";
export default {
  components: {
    irrigationVue,
    zzymVue,
  },
  props: {
    zoom: {
      type: Number,
    },
  },
  data() {
    return {
      zzym: false, //制种玉米弹窗
      dialogFormVisible: false,
      form: {
        num: "",
        kd: "",
        time: "",
        sort: "",
      },
      markersWaterSet: [],
      markersGroupList: [],
      groupPolyline: null,
      groupPolylineList: [],
      markersOpenGroup: false,
      player: null,
      monitorUrl: "", // 用于保存视频流地址
      irrigation: false,
      dialogVisible: false,
      dialogMqVisible: false,
      dialogCqVisible: false,
      dialogSqVisible: false,
      dialogQxVisible: false,
      dialogBzVisible: false,
      map: null,
      markers: [],
      value1: false,
      value2: false,
      value3: false,
      value4: false,
      value5: false,
      value6: false,
      operatingMode: true, //运行模式 true 手动 false 自动

      tableList: [
        {
          show: false,
          ischeck: false,
          tableData: [
            {
              name: "水阀1",
              status: "开启",
              dl: "72%",
              time: "300",
              kd: "100%",
              sy: "65",
              ll: "120",
              timeCount: "1800",
            },
            {
              name: "水阀2",
              status: "关闭",
              dl: "60%",
              time: "300",
              kd: "0%",
              sy: "0",
              ll: "0",
              timeCount: "0",
            },
            {
              name: "水阀3",
              status: "开启",
              dl: "72%",
              time: "300",
              kd: "20%",
              sy: "0.2",
              ll: "110",
              timeCount: "600",
            },
            {
              name: "水阀4",
              status: "关闭",
              dl: "60%",
              time: "300",
              kd: "0%",
              sy: "0",
              ll: "0",
              timeCount: "0",
            },
          ],
        },
        {
          show: false,
          ischeck: false,
          tableData: [
            {
              name: "水阀1",
              status: "开启",
              dl: "72%",
              time: "300",
              kd: "100%",
              sy: "65",
              ll: "120",
              timeCount: "1800",
            },
            {
              name: "水阀2",
              status: "开启",
              dl: "76%",
              time: "300",
              kd: "100%",
              sy: "65",
              ll: "120",
              timeCount: "1800",
            },
          ],
        },
        {
          show: false,
          ischeck: false,
          tableData: [
            {
              name: "水阀1",
              status: "关闭",
              dl: "70%",
              time: "0",
              kd: "0",
              sy: "0",
              ll: "0",
              timeCount: "600",
            },
            {
              name: "水阀2",
              status: "关闭",
              dl: "85%",
              time: "0",
              kd: "0",
              sy: "0",
              ll: "0",
              timeCount: "600",
            },
          ],
        },
        {
          show: false,
          ischeck: false,
          tableData: [
            {
              name: "水阀5",
              status: "关闭",
              dl: "52%",
              time: "300",
              kd: "0%",
              sy: "0",
              ll: "0",
              timeCount: "0",
            },
            {
              name: "水阀6",
              status: "关闭",
              dl: "38%",
              time: "300",
              kd: "0%",
              sy: "0",
              ll: "0",
              timeCount: "0",
            },
            {
              name: "水阀7",
              status: "关闭",
              dl: "25%",
              time: "300",
              kd: "0%",
              sy: "0",
              ll: "0",
              timeCount: "0",
            },
            {
              name: "水阀8",
              status: "关闭",
              dl: "64%",
              time: "300",
              kd: "0%",
              sy: "0",
              ll: "0",
              timeCount: "0",
            },
          ],
        },
      ],
    };
  },
  async mounted() {
    // const config = {
    //   id: "mse",
    //   url:
    //     "https://cmgw-vpc.lechange.com:8890/flv/LCO/7L04FEFPAN83F0B/0/1/20230404161935/2dd0e90254801b4184a069e430303815.flv?proto=https",
    //   playsinline: true,
    //   plugins: [],
    //   videoInit: true,
    //   ignores: ["fullscreen"],
    //   width: "90%",
    //   height: "90%",
    //   cssFullscreen: true,
    // };
    // config.plugins.push(FlvPlugin);
    // let player = new Player(config);
    this.$request("iot/map/water").then((res) => {
      this.initMap(res.data);
    });
    this.setShow(true);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  // mounted() {

  // },
  methods: {
    openOrCloseDevice() {
      this.$confirm("此操作将会同步操作现场水阀，请谨慎操作", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            message: "暂无操作权限",
            type: "warning",
          });
        })
        .catch(() => {});
    },
    openKeyGroup() {
      console.log(this.tableList);
      let da = [];
      for (let i = 0; i < this.tableList.length; i++) {
        if (this.tableList[i].ischeck) {
          da.push("1");
        }
      }
      if (da.length == 0) {
        this.$message("请选择分组");
      } else {
        this.dialogFormVisible = true;
      }
    },
    start() {
      this.$confirm(" 该操作会进行现场灌溉，请谨慎操作", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisible = false;
        })
        .catch(() => {});
    },
    //设置展开收起
    setShow(e) {
      for (let i = 0; i < this.tableList.length; i++) {
        this.tableList[i].show = e;
      }
    },
    initMap(mapData) {
      let that = this;
      return new Promise((resolve) => {
        window._AMapSecurityConfig = {
          securityJsCode: "04cd79a4c5495df5b89aa3a4039c153f", // 自2021年12月02日升级后, key与安全密钥必须一起使用, 否则可能会出现一些API无法使用，如 DistrictSearch
        };
        AMapLoader.load({
          key: "9224554f73c18efca0ab55f8909f162e", // 首次调用 load 时必填
          version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins: [
            "AMap.DistrictSearch", // 配置行政区查询服务
            "AMap.GeoJSON", // 配置行政区查询服务
          ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
          Loca: {
            // 是否加载 Loca， 缺省不加载
            version: "2.0.0", // Loca 版本，缺省 1.3.2
          },
        })
          .then((AMap) => {
            this.googleSatelliteDomestic = new AMap.TileLayer({
              tileUrl:
                "https://map.snkoudai.com/maps/vt/lyrs=s&hl=zh-CN&gl=cn&scale=1&x=[x]&y=[y]&z=[z]",
            });

            var imageLayer = new AMap.ImageLayer({
              url: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%B0%B4%E9%98%80%E5%9B%BE%403x.png",
              bounds: new AMap.Bounds(
                [100.348928, 38.897934],
                [100.378626, 38.914551]
              ),
              zooms: [15, 20],
              zIndex: 150,
            });

            //基础图层
            this.map = new AMap.Map("contnChow1232", {
              center: [100.362315, 38.904672], // 中心点坐标
              mapStyle: "amap://styles/darkblue", //地图颜色样式
              viewMode: "3D", //是否启用3d地图
              pitch: 50, //设置倾斜度
              // zoom: 7.7,
              zoom: this.zoom,
              skyColor: "#395a85", //天空颜色
              resizeEnable: true,
              showLabel: false,
              layers: [this.googleSatelliteDomestic],
              animateEnable: true,
            });

            //画在地图图层上,map是地图对象
            var mapOverLayer = new AMap.OverlayGroup();
            this.map.add(mapOverLayer); //新建图层，将图层添加到地图上

            var dkColor = [
              "rgb(37, 170, 128)",
              "#7ebe7a",
              "#6c924f",
              "#3f8a3b",
            ];
            for (let i = 0; i < mapData.length; i++) {
              let data = JSON.parse(mapData[i].latLonPath);
              var polygon = new AMap.Polygon({
                path: data.map((item) => {
                  return [item.longitude, item.latitude];
                }),
                strokeColor: "#fff",
                strokeWeight: 2,
                strokeOpacity: 1,
                // strokeStyle: 'dashed',
                fillColor: dkColor[i],
                fillOpacity: 0.5,
                lineJoin: "round", //折线拐点的绘制样式，默认值为'miter'尖角，其他可选值：'round'圆角、'bevel'斜角
                lineCap: "round", //折线两端线帽的绘制样式，默认值为'butt'无头，其他可选值：'round'圆头、'square'方头
                extData: mapData[i],
              });
              this.map.add(polygon);
              polygon.on("click", function (e) {
                console.log(e);
                console.log(e.target.getExtData());
                // that.$router.push('farming',{id:e.target.getExtData().id})
                // that.$router.push({
                //   path: "/farming",
                //   query: { id: e.target.getExtData().id, type: 2 },
                // });
              });

              let poliList = mapData[i].waterPipe.split("#");
              for (let j = 0; j < poliList.length; j++) {
                let data2 = JSON.parse(poliList[j]);
                let path = data2.map((item) => {
                  return [item.longitude, item.latitude];
                });

                var Polyline = new AMap.Polyline({
                  path: data2.map((item) => {
                    return [item.longitude, item.latitude];
                  }),
                  strokeWeight: 5,
                  // strokeColor: dkColor[i],
                  strokeColor: "#97EDFF",
                  // 使用纹理线
                  lineJoin: "round",
                  lineCap: "round",
                  strokeDasharray: [10, 5], // 虚线间隔
                  showDir: true,
                  isOutline: true,
                  outlineColor: "#fff",
                  zIndex: 90,
                });
                this.map.add(Polyline);

                var Polyline2 = new AMap.Polyline({
                  path: data2.map((item) => {
                    return [item.longitude, item.latitude];
                  }),
                  strokeWeight: 3,
                  // strokeColor: dkColor[i],
                  strokeColor: "#005ACF",
                  strokeOpacity: 0.4,
                  // 使用纹理线
                  lineJoin: "round",
                  lineCap: "round",
                  strokeDasharray: [10, 5], // 虚线间隔
                  showDir: true,
                  isOutline: true,
                  outlineColor: "blue",
                  zIndex: 91,
                });
                this.map.add(Polyline2);
              }
            }

            var markerIcon = new AMap.Icon({
              size: new AMap.Size(134, 134),
              image:
                "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/dadian.png",
              imageSize: new AMap.Size(134, 134),
              // 图标取图偏移量
              imageOffset: new AMap.Pixel(-9, -3),
            });
            // 自定义点标记内容
            var markerContent = document.createElement("div");
            // 点标记中的文本
            var markerSpan = document.createElement("span");
            markerContent.className = "marker-name";
            markerSpan.innerHTML = "新敦镇双堡村";
            markerContent.appendChild(markerSpan);
            var markers = new AMap.Marker({
              position: [100.362315, 38.904672],
              offset: new AMap.Pixel(-0, 24),
            });
            markers.setContent(markerContent); //更新点标记内容
            this.map.add(markers);

            //右键单击也可以返回
            markers.on("click", (e) => {
              this.map.setZoom(15);
              this.map.setCenter([100.362315, 38.904672]);
            });

            // 点标记显示内容，HTML要素字符串
            var markerContent =
              "" +
              '<div class="custom-content-marker"><div>张掖市</div><div>zhangye</div></div>';
            var marker = new AMap.Marker({
              position: [101.262315, 40.504672],
              // 将 html 传给 content
              // content: markerContent,
              icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%BC%A0%E6%8E%96%E5%B8%82.png",
              // 以 icon 的 [center bottom] 为原点
              offset: new AMap.Pixel(-13, -30),
            });

            // 将 markers 添加到地图
            this.map.add(marker);
            marker.on("click", (e) => {
              //打开制种玉米弹窗
              this.zzym = true;
            });

            this.map.on("complete", () => {
              resolve();
              this.getBoundaries(AMap, this.map);
            });
            this.map.on("click", function (e) {
              console.log(e);
            });
          })
          .catch((e) => {
            console.log(e);
          });
      });
    },
    // 2.获取边界
    getBoundaries(AMap, map) {
      const district = new AMap.DistrictSearch({
        subdistrict: 0,
        // 返回行政区边界坐标点
        extensions: "all",
      }); //注意：需要使用插件同步下发功能才能这样直接使用
      district.search("张掖市", (status, result) => {
        if (status == "complete") {
          var loca = (window.loca = new Loca.Container({
            map,
          }));

          var ambLight = new Loca.AmbientLight({
            intensity: 1,
            color: "#fff",
          });
          loca.addLight(ambLight);

          fetch(
            "https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/pc/geoJson/%E7%94%98%E8%82%83%E7%9C%813.geoJson"
          )
            .then((response) => response.json())
            .then((dataJSON) => {
              var geo = new Loca.GeoJSONSource({
                data: dataJSON,
                // url:'https://a.amap.com/Loca/static/loca-v2/demos/mock_data/hz_gn.json'
              });
              // var height = [10, 20, 40, 60, 80, 100, 120, 140, 160];
              // height = height.map(h => h * 2)
              var pl = new Loca.PolygonLayer({
                zIndex: 100,
                cullface: "none",
                shininess: 1,
                hasBottom: false,
                blockHide: false,
                hasSide: true,
                hasTop: false,
                depth: false,
              });

              pl.setSource(geo);
              pl.setStyle({
                topColor: function (index, feature) {
                  return "rgba(255,255,255,1)";
                },
                sideTopColor: function (index, feature) {
                  return "rgba(255,255,255,0.6)";
                },
                height: function (index, feature) {
                  var v = feature.properties.health * 160;
                  // return v * v;
                  return 15000;
                },
              });
              loca.add(pl);
            });

          var outer = [
            new AMap.LngLat(-360, 90, true),
            new AMap.LngLat(-360, -90, true),
            new AMap.LngLat(360, -90, true),
            new AMap.LngLat(360, 90, true),
          ];
          var holes = result.districtList[0].boundaries;

          var pathArray = [outer];
          pathArray.push.apply(pathArray, holes);
          var polygon = new AMap.Polygon({
            pathL: pathArray,
            strokeColor: "#00eeff",
            strokeWeight: 1,
            fillColor: "#233622",
            fillOpacity: 0.8,
          });
          polygon.setPath(pathArray);
          this.map.add(polygon);
        }
      });
    },
    setMarkers(e) {
      let that = this;
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach((marker) => {
          marker.setMap(null); // 或者 marker.remove();
        });
        this.markers = []; // 清空数组，准备下次使用
      }
      if (this.groupPolylineList && this.groupPolylineList.length > 0) {
        this.groupPolylineList.forEach((groupPolylineList) => {
          groupPolylineList.setMap(null); // 或者 marker.remove();
        });
        this.groupPolylineList = []; // 清空数组，准备下次使用
      }

      console.log(e);

      if (e.data[0].type == 2) {
        //水阀分组列表  获取水阀分组  地图上连线
        this.$request("iot/valve/group/list/new").then((res) => {
          for (var i = 0; i < res.data.length; i++) {
            for (var j = 0; j < res.data[i].valveGroupList.length; j++) {
              let point = [];
              for (
                var k = 0;
                k < res.data[i].valveGroupList[j].valveSets.length;
                k++
              ) {
                this.markersWaterSet.push(
                  res.data[i].valveGroupList[j].valveSets[k].deviceId
                );

                point.push(
                  transformWGS84ToGCJ02(
                    res.data[i].valveGroupList[j].valveSets[k].lon,
                    res.data[i].valveGroupList[j].valveSets[k].lat
                  )
                );
              }

              var groupPolyline = new AMap.Polyline({
                path: point,
                strokeWeight: 6,
                strokeColor: "#e3ff85",
                // 使用纹理线
                lineJoin: "round",
                lineCap: "round",
                // strokeDasharray: [10, 5], // 虚线间隔
                // showDir: true,
                isOutline: true,
                outlineColor: "#fff",
                zIndex: 90,
                strokeOpacity: 1,
              });
              that.groupPolylineList.push(groupPolyline);
              that.map.add(groupPolyline);
            }
          }
        });
      }

      for (let i = 0; i < e.data.length; i++) {
        var image = "";
        // 1水肥 2水阀 3监控 4 气象 5 土壤 6 孢子 7 虫情监测仪 8 虫情灯
        switch (e.data[i].type) {
          case 1:
            image =
              "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%B4%E8%82%A5%E6%9C%BA%E8%AE%BE%E5%A4%87%402x.png";
            break;
          case 2:
            image =
              "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%B4%E9%98%80%E8%AE%BE%E5%A4%872%402x.png";
            break;
          case 3:
            image =
              "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E8%8B%97%E6%83%85%E8%AE%BE%E5%A4%87%402x.png";
            break;
          case 4:
            // this.deviceCount[1].num = res.data[i].deviceCount
            image =
              "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%94%E8%B1%A1%E8%AE%BE%E5%A4%87%402x.png";
            break;
          case 5:
            image =
              "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E5%A2%92%E6%83%85%E8%AE%BE%E5%A4%87%402x.png";
            break;
          case 6:
            image =
              "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E5%AD%A2%E5%AD%90%E8%AE%BE%E5%A4%87%402x.png";
            break;
          case 7:
            image =
              "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E8%99%AB%E6%83%85%E8%AE%BE%E5%A4%87%402x.png";
            break;
          case 8:
            image =
              "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%9D%80%E8%99%AB%E7%81%AF%E8%AE%BE%E5%A4%87%402x.png";
            break;
          default:
            break;
        }
        var markerIcon = null;
        if (e.data[i].type == 2) {
          markerIcon = new AMap.Icon({
            size: new AMap.Size(30, 40),
            image: image,
            imageSize: new AMap.Size(30, 40),
            // 图标取图偏移量
            // imageOffset: new AMap.Pixel(-9, -3)
          });
        } else {
          markerIcon = new AMap.Icon({
            size: new AMap.Size(47, 92),
            image: image,
            imageSize: new AMap.Size(47, 92),
            // 图标取图偏移量
            imageOffset: new AMap.Pixel(-9, -3),
          });
        }

        var markers = new AMap.Marker({
          position:
            e.data[i].type == 2
              ? transformWGS84ToGCJ02(e.data[i].lon, e.data[i].lat)
              : [e.data[i].lon, e.data[i].lat],
          icon: markerIcon,
          offset:
            e.data[i].type == 2
              ? new AMap.Pixel(-8, -40)
              : new AMap.Pixel(-8, -80),
          extData: e.data[i],
        });
        markers.on("click", function (e) {
          console.log(e.target.getExtData());
          var data = e.target.getExtData();
          // 1水肥 2水阀 3监控 4 气象 5 土壤 6 孢子 7 虫情监测仪 8 虫情灯
          if (data.type == 1) {
            console.log("水肥机");
            that.irrigation = true;
          }
          if (data.type == 3) {
            console.log("监控");

            // 获取视频地址
            const videoUrl = JSON.parse(data.config).live_flv_hd;
            console.log(videoUrl);

            // 显示弹窗
            that.dialogMqVisible = true;

            // 等DOM渲染完成再挂载播放器
            that.$nextTick(() => {
              // 销毁旧的
              if (that.player) {
                that.player.destroy();
                that.player = null;
              }

              // 创建新的
              that.player = new Player({
                id: "mse",
                url: videoUrl,
                playsinline: true,
                width: 800,
                height: 450,
                videoInit: true,
                cssFullscreen: true,
                ignores: ["fullscreen"],
                plugins: [FlvPlugin],
                autoplayMuted: true,
                autoplay: true,
              });

              // 添加错误事件监听
              that.player.on("error", (err) => {
                console.error("播放器错误：", err);
              });
            });
          }
          if (data.type == 7) {
            that.dialogCqVisible = true;
          }
          if (data.type == 5) {
            that.dialogSqVisible = true;
          }
          if (data.type == 4) {
            that.dialogQxVisible = true;
          }
          if (data.type == 6) {
            that.dialogBzVisible = true;
          }

          if (data.type == 2) {
            if (!that.markersOpenGroup) {
              return;
            }
            if (that.markersWaterSet.includes(data.id)) {
              return;
            }
            that.markersWaterSet.push(data.id);
            that.markersGroupList.push(
              transformWGS84ToGCJ02(data.lon, data.lat)
            );
            if (that.markersGroupList.length > 1) {
              if (that.groupPolyline) {
                that.map.remove(that.groupPolyline);
              }
              that.groupPolyline = new AMap.Polyline({
                path: that.markersGroupList,
                strokeWeight: 6,
                strokeColor: "#97EDFF",
                // 使用纹理线
                lineJoin: "round",
                lineCap: "round",
                // strokeDasharray: [10, 5], // 虚线间隔
                // showDir: true,
                isOutline: true,
                outlineColor: "#fff",
                zIndex: 90,
              });
              that.map.add(that.groupPolyline);
            }
          }
        });
        this.map.add(markers);
        this.markers.push(markers);
      }
    },
    openGroupMarkers() {
      this.markersOpenGroup = true;
    },
    closeGroupMarkers() {
      this.markersOpenGroup = false;
      this.dialogVisible = true;
      this.markersGroupList = [];
      // this.markersWaterSet = [];
      this.map.remove(this.groupPolyline);
      this.groupPolyline = null;

      // console.log(this.groupPolyline);

      // this.groupPolyline.destroy()
    },
    openGroup() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style>
.marker-name {
  width: 134px;
  height: 137px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/dadian.png");
  background-size: 100% 100%;
  font-size: 16px;
  text-align: center;
  line-height: 35px;
}
</style>
<style lang="scss" scoped>
.sqtext {
  font-size: 16px;
  color: #fff;
  line-height: 40px;
  padding-left: 10px;
}
.dialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1500;

  .dialog-close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 99;
    cursor: pointer;
  }

  .table-name {
    font-size: 20px;
  }

  .table-search {
    font-size: 15px;
  }

  /* 移除所有内部边框 */
  .outer-border-table >>> .el-table__body tr td,
  .outer-border-table >>> .el-table__body tr th,
  .outer-border-table >>> .el-table__header-wrapper tr th {
    border: none !important;
  }

  /* 添加外边框 */
  .outer-border-table {
    border: 1px solid #ebeef5;
    border-radius: 4px;
  }

  /* 移除默认的表格边框 */
  .outer-border-table >>> .el-table__header,
  .outer-border-table >>> .el-table__body,
  .outer-border-table >>> .el-table__footer {
    border: none !important;
  }

  .search {
    height: 31px;
    line-height: 31px;
    background: #366ec0;
    border-radius: 4px;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    margin-right: 10px;
    padding: 0 10px;
    cursor: pointer;
  }

  .search2 {
    height: 31px;
    background: #366ec0;
    border-radius: 4px;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    margin-right: 10px;
    padding: 0 10px;
    cursor: pointer;
  }

  .mask {
    width: 100vw;
    height: 100vh;
    z-index: 1500;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
  }

  .cont {
    position: relative;
    z-index: 1501;
    background-color: #fff;
    border-radius: 20px;
  }
}

.custom-content-marker {
  font-weight: 900;
  font-size: 36px;
  color: #f6e18b;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#contnChow1232 {
  border-radius: 5px;
  width: 100vw;
  height: 100vh;
  position: relative;

  color: #7ebe7a;
}

.cq {
  .sd {
    width: 90px;
    height: 30px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%89%8B%E5%8A%A8%402x%20%282%29.png");
    background-size: 100% 100%;

    font-weight: 500;
    font-size: 14px;
    color: #fff;
    line-height: 30px;
    text-align: center;
  }

  .zd {
    width: 90px;
    height: 30px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%87%AA%E5%8A%A8%402x%20%281%29.png");
    background-size: 100% 100%;

    font-weight: 500;
    font-size: 14px;
    color: #fff;
    line-height: 30px;
    text-align: center;
  }

  /* 修改选中时的背景色 */
  ::v-deep .el-switch.is-checked .el-switch__core {
    background-color: rgba(0, 180, 255, 0.4) !important;
    border-color: #53c556 !important;
  }

  /* 修改未选中时的背景色 */
  ::v-deep .el-switch__core {
    background-color: #a19f9f !important;
    // border-color: #b2b2b2 !important;
  }

  .ai-list {
    width: 620px;
    height: 36px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E4%BF%A1%E6%81%AF%E6%A0%8F%402x.png");
    background-size: 100% 100%;

    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
  }

  .aifx-title {
    width: 620px;
    height: 36px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E6%A0%87%E9%A2%98%E6%A0%8F%402x.png");
    background-size: 100% 100%;

    font-weight: 500;
    font-size: 14px;
    color: #00ffd1;
    text-align: center;
  }

  .el-input__inner {
    background: linear-gradient(
      180deg,
      rgba(0, 87, 202, 0.3) 0%,
      rgba(0, 23, 54, 0.64) 100%
    ) !important;
    border-radius: 2px !important;
    border: 1px solid !important;
    border-image: linear-gradient(
        124deg,
        rgba(156, 211, 225, 0),
        rgba(194, 243, 255, 1),
        rgba(156, 211, 225, 0)
      )
      1 1 !important;
  }

  ::v-deep .el-range-input {
    background: rgba(156, 211, 225, 0) !important;
    cursor: pointer;
  }

  ::v-deep .el-range-separator {
    color: #fff !important;
  }

  .cjsj {
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-right: 10px;
  }

  .search {
    width: 73px;
    height: 31px;
    background: #366ec0;
    border-radius: 2px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  .cq-right-top-title2 {
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-right: 2px;
    width: 60px;
  }

  .cq-right-top-title {
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-right: 12px;
    width: 60px;
  }
  .switch-group {
    display: flex;
    flex-direction: column; /* 垂直方向 */
    align-items: center; /* 居中对齐 switch 与文字 */
    margin-top: -20px;
  }

  .cq-right-top-status {
    // font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 4px; /* 状态文字与 switch 间距 */
  }

  .paizhao {
    width: 88px;
    height: 30px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;

    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    margin-right: 20px;
  }
}

.fout-emotions-title {
  height: 38px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A0%87%E9%A2%98%402x%20%281%29.png");
  background-size: 100% 100%;
  font-family: YouSheBiaoTiHei;
  font-size: 20px;
  color: #c4dcf0;
  line-height: 38px;
  padding-left: 30px;
}
</style>
